import React from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ToastMessage = () => {
  return <ToastContainer />;
};

export default ToastMessage;

/* import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Snackbar, Alert} from '@mui/material';
const ToastMessage = () => {
    const dispatch = useDispatch();
    const { loading, error,message } = useSelector((state) => state.auth);
    const [open, setOpen] = useState(false);
    const handleClose = (event, reason) => {
        setOpen(false);
    };
    return <>
        <Snackbar open={open} autoHideDuration={5000} onClose={handleClose}>
            <Alert onClose={handleClose} severity={error ? 'error' : 'success'} sx={{ width: '100%' }}>
            {error ? error : message}
            </Alert>
        </Snackbar>
    </>
}
export default ToastMessage; */